import { render, staticRenderFns } from "./RescheduleFollowUp.vue?vue&type=template&id=a0f8ec70&scoped=true&"
import script from "./RescheduleFollowUp.vue?vue&type=script&lang=ts&"
export * from "./RescheduleFollowUp.vue?vue&type=script&lang=ts&"
import style0 from "./RescheduleFollowUp.vue?vue&type=style&index=0&id=a0f8ec70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f8ec70",
  null
  
)

export default component.exports